/**
 * Singleton that manages the portal search
 */
// portalSearch
define(['jquery', 'c21/track', 'c21/ajax', 'c21/freeTextSearch', 'c21/TallLoadingIndicator', 'c21/SearchDropAnimator', 'c21/WordCollapsasaurus', 'c21/listhub', 'c21/internationalization', 'c21/suggestPortalExtension', 'jqueryeffects'], function ($, track, ajax, freeTextSearch, TallLoadingIndicator, SearchDropAnimator, WordCollapsasaurus, listhub, internationalization, suggestPortalExtension) {
   "use strict";

   var self,
      m_strDefaultText, m_iSuggestTimeout, m_jBox, m_jReset, m_jButton,
      m_strLastRequest, m_bTextDirty, m_iChangeTimeout, m_bIndexPage, m_bHasFocus,
      m_jBehind, m_tooltip, m_bUserStoppedTooltip,

      m_aC21ListingGuids = [],
      m_aC21Listings = [],
      m_aAgents = [],
      m_aOffices = [];

   /**
    * Request a portal search
    * @param bEnterPressed Whether the user pressed enter to trigger the search
    */
   function doPortalSearch(bEnterPressed) {
      var val = m_jBox.val(), options;
      var suggestType = $("#suggestType").val();
      var isExactLocationMatch = $("#isExactLocationMatch").val();

      // Perform a submit and search for the single location properties or an exact matched location properties
      if ((suggestType === 'SINGLE_LOCATION' || isExactLocationMatch === 'true') && bEnterPressed) {
         var locationID = $("#singleLocationID").val();
         if (locationID && locationID.length > 0) {
            freeTextSearch.gaTrackExactLocationMatch(locationID, $("#singleLocationType").val());
            freeTextSearch.propertySearch(locationID, 'N', bEnterPressed);
            return false;
         }    
      } 

      // GA Tracking - Exact Match Details (Property/Agent/Office)
      if (suggestType === 'SINGLE_PROPERTY' && bEnterPressed) {
         var brandCd = $("#propertyBrandCd").val();
         track.doEvent('Free Text Search', 'Select property details for brand ' + brandCd);
      }

      if (suggestType === 'SINGLE_AGENT' && bEnterPressed) {
         track.doEvent('Free Text Search', 'Select agent details');
      }

      if (suggestType === 'SINGLE_OFFICE' && bEnterPressed) {
         track.doEvent('Free Text Search', 'Select office details');
      }
      
      // Why would you search for the default text?
      if (val === m_strDefaultText) {
         return;
      }
      
      if (bEnterPressed || (val !== m_strLastRequest)) {
         options = {
            loadingIndicator : new TallLoadingIndicator('#innerSearch'),
            cache: true
         };
         m_jBox.addClass('searchValue');
         m_bTextDirty = true;
         m_strLastRequest = val;
         ajax.doViewEngineAjax('indexView.SuggestSubView',
               '/eco/freetextsearch/', 'query=' + encodeURIComponent(val) +
                  ((bEnterPressed) ? '&enter=1' : ''), options);
      } else if (m_strLastRequest) {
         if (!m_bHasFocus) {
            return;
         }
      
         SearchDropAnimator.showSearchDrop();
      }
   }

   /**
    * Add an agent to track
    */
   function pushAgent(key){
      m_aAgents.push(key);
   }

   /**
    * Add an office to track
    */
   function pushOffice(key){
      m_aOffices.push(key);
   }

   /**
    * Add a listing to track
    */
   function pushC21Listing(listingkey, listingGUID){
      // If the key does not contain CBR, ERA or LCE...
      if (listingkey.indexOf("CBR") < 0 && listingkey.indexOf("ERA") < 0 && listingkey.indexOf("LCE") < 0) {
         m_aC21Listings.push(listingkey.replace("C21", ""));
         m_aC21ListingGuids.push(listingGUID);
      }
   }

   /**
    * Track Agents
    */
   function trackAgents() {
      if (m_aAgents.length !== 0) {
         trackInternally(m_aAgents, 'agent');
      }
   }

   /**
    * Track Offices
    */
   function trackOffices() {
      if (m_aOffices.length !== 0) {
         trackInternally(m_aOffices, 'office');
      }
   }

   /**
    * Track Listings
    */
   function trackListings() {
      if (m_aC21Listings.length === 0) {
         return;
      }

      trackInternally(m_aC21Listings, 'listing');

      // ListHub tracking
      if ($.browser.msie  && parseInt($.browser.version) === 7) {
         // Do not use listhub, otherwise IE7 would bomb out
      } else {
         // Smart browser
         $.each(m_aC21ListingGuids, function(i, c21Listing) {
            listhub.doTrackingC21(c21Listing, 'SEARCH_DISPLAY');
         });
      }
   }

   /**
    * Send an AJAX request to internally track items
    *
    * @param aItemIds         the ids of items to be tracked
    * @param strTrackingType  the type of item being tracked ('agent', 'listing', etc)
    */
   function trackInternally(aItemIds, strTrackingType) {
      // Track internally
      var strItemIds = "id=" + aItemIds.join("&id=");
      ajax.report({
         url: "/reporting/" + strTrackingType,
         data: strItemIds + "&type=RetSearch"
      });
   }

   function doSearchShowEvent() {
      var val = m_jBox.val();
      
      m_bTextDirty = true;
      if (val.length === 0) {
         m_jReset.hide();
         SearchDropAnimator.hideSearchDrop();
      } else if (val !== m_strDefaultText) {
         m_jReset.show();         
         if ((val.length >= 3) || (val.length >= 1 && $("#e").val() === 1)) {
            clearTimeout(m_iSuggestTimeout);
            m_iSuggestTimeout = setTimeout(doPortalSearch, 100, false);
         } else {
            SearchDropAnimator.hideSearchDrop();
         }
      }
   }

   function setBehindText(str) {
      if (str) {
         var strSearchVal = m_jBox.val(),
            strBackgroundValue = strSearchVal + str.slice(strSearchVal.length);
   
         if (strSearchVal.toLowerCase() === str.slice(0, strSearchVal.length).toLowerCase()) {
            m_jBehind.val(strBackgroundValue);
         } else {
            m_jBehind.val('');
         }
      }
   }

   function showSearchHint(str, fnOnFinish) {
      var iFadeTime = 100,

         // Get the value of the original text
         strOriginalText = m_jBox.val();

      m_jBox.fadeOut(iFadeTime, function() {
         var strNewText = m_jBox.val();

         // If the text has changed while the animation was underway
         // (for instance, user clicks inside text box and changes stuff)
         if (strOriginalText !== strNewText) {
            m_jBox.show();

            // Abort!!
            return;
         }

         m_jBox.val(str);
         m_jBox.fadeIn(iFadeTime, fnOnFinish);
      });
   }

   function onSubmit() {
	  track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations by Search C21 button click');
      doPortalSearch(true);
   }
   
   function onReset() {
      m_jBox.val('');
      onChange();
      m_jBox.focus();
      updateBackgroundValue();
   }

   function updateBackgroundValue() {
      var strSearchVal = m_jBox.val(),
         strBackgroundValue = m_jBehind.val();

      if ((strSearchVal === '') || (strSearchVal !== strBackgroundValue.slice(0, strSearchVal.length))) {
         m_jBehind.val('');
      }
   }
   
   function onChange() {
      clearTimeout(m_iChangeTimeout);
      clearTimeout(m_iSuggestTimeout);

      // setTimeout to prevent animation collision
      m_iChangeTimeout = setTimeout(doSearchShowEvent, 20);
   }
   
   function onFocus() {
      m_jBehind.removeClass("searchHidden");
      m_bHasFocus = true;
      if (!m_jBox.hasClass('searchValue')) {
         m_jBox.addClass('searchValue');
         m_jBox.val('');
      }

      //Clear the enter key stroke event
      $("#e").val("");

      doSearchShowEvent();
      stopTooltip();
   }
   
   function onBlur() {
      m_jBehind.removeClass("searchHidden");
      m_bHasFocus = false;
      if ($.trim(m_jBox.val()) === '') {
         m_jBox.val(m_strDefaultText);
         m_jBox.removeClass('searchValue');
      }
   }
   
   function fixExpanding() {
      var jExpandingDivs = $("#locationResultsInnerDiv, #propertyResultsInnerDiv, #officeResultsInnerDiv, #agentResultsInnerDiv");

      jExpandingDivs.click(function(e) {
         if (e.target !== this) {
            return; // only continue if the target itself has been clicked
         }

         var jThis = $(this);
         jThis.find('.moreLinkDiv a, .showLessLinkDiv a').click();
      });
   }

   function doCollapsing() {
      $(".ftsCollapse").each(function() {new WordCollapsasaurus($(this));});
   }
   
   function enlargeClickTargets() {
      var bSuggestIconClicked = false;

      //$(".disabledSuggestIcon").find("a").attr("href", "javascript:void(0);");
      $(".suggestIcon").hover(
         function() {$(this).addClass('hover');}, 
         function() {$(this).removeClass('hover');})
      .click(function() {
         if (bSuggestIconClicked) {
            return;
         }

         bSuggestIconClicked = true;

         var jLink = $(this).find("a");
         if (jLink.attr("onclick")) {
            jLink.click();
         }

         document.location.href = jLink.attr("href");
      });
   }

   /**
    * Handles finding highlighted matches
    * @param strNeedle  the string to look up
    * @param strHaystack the string to look at
    * @return a matche with beginning/end character positions
    */
   function getHighlightPositions(strNeedle, strHaystack) {
      // Regex to eliminate unnecessary characters
      var regCondense = /([^a-z0-9]| )/gi,

         // Needle without unnecessary characters
         strNeedleCondensed = strNeedle.replace(regCondense, '').toLowerCase(),

         // The beginning / end indexes of a word in the condensed haystack
         iBeginIndex = 0,
         iEndIndex = 0,

         strSearch = '(^|[^a-z0-9])(' + strNeedleCondensed.split('').join('([^a-z0-9]*|[^a-z0-9]+(street|drive|st|rd|blvd|ln)[^a-z0-9]+)?') + ')([^a-z0-9]*)',
         regSearch = new RegExp(strSearch, 'i'),
         result = strHaystack.match(regSearch);

      if (result !== null) {
         iBeginIndex = result.index;

         if (result[1].length > 0) {
            iBeginIndex++;
         }

         var iTrailHaystack = result[result.length - 1].length,
            matchTrailNeedle = strNeedle.match(/[^a-z0-9]*$/),
            iTrailNeedle = 0,
            iTrail = 0;

         if (matchTrailNeedle !== null) {
            iTrailNeedle = matchTrailNeedle[0].length;
            iTrail = Math.min(iTrailHaystack, iTrailNeedle);
         }

         iEndIndex = result.index + result[0].length - 1 - iTrailHaystack + iTrail;

         return {
            begin: iBeginIndex,
            end: iEndIndex
         };
      }

      return null;
   }

   function doHighlight() {
      var strSearch = m_jBox.val(),
         jContent = $("#dropdownContent"),
         jAllItems = jContent.find('.ftsHighlight, .ftsHighlightMls');

      // If there's nothing to look for then why bother?
      if ($.trim(strSearch) === '') {
         return;
      }

      // Remove previous instances of highlighting
      jContent.find("span.freetextsearchmatched").contents().unwrap();

      jAllItems.each(function(i, el) {
         var jItem = $(el),
            jCollapsedItem = jItem.find('span span');

         // Sometimes the Collapsasaurus runs before this.
         // We want that to work, but we don't want html
         // mixed up in here
         if (jCollapsedItem.length > 0) {
            jItem = jCollapsedItem.eq(0);
         }

         // Use .text() so as to disregard HTML, &nbsp; or
         // any other funny stuff that could accidentally be highlighted
         var strText = jItem.text(),
            strNewHtml = strText,
            match = getHighlightPositions(strSearch, strText);

         if (strText === "") return;
         if (match === null) return;

         var iBegin = match.begin,
            iEnd = match.end - match.begin + 1;

         strNewHtml = strNewHtml.substr(0, iBegin) + "<span class='freetextsearchmatched'>" +
            strNewHtml.substr(iBegin, iEnd) + '</span>' + strNewHtml.substr(iBegin + iEnd);

         jItem.html(strNewHtml);
      });
   }
   
   function onKeyDown(event) {
      var iKeyCode = event.keyCode;

      // ENTER key
      if (iKeyCode === 13) {
         //GA Tracking - enter key
         track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations with enter key');
          
         doPortalSearch(true);
         return false;
      // UP arrow
      } else if (iKeyCode === 38) {
         suggestPortalExtension.moveUp();
         return false;
      // RIGHT arrow or TAB key
      } else if (iKeyCode === 39 || iKeyCode === 9) {
         var strBehindText = m_jBehind.val();
         if (strBehindText) {
            m_jBehind.val('');
            m_jBox.val(strBehindText);
            onChange();
            return false;
         }
      // DOWN arrow
      } else if (iKeyCode === 40) {
         suggestPortalExtension.moveDown();
         return false;
      } else {
         onChange();
      }
   }

   function stopTooltip() {
      m_bUserStoppedTooltip = true;
      if (m_tooltip) {
         m_tooltip.hide();
      }
   }

   self = {
      pushC21Listing: pushC21Listing,
      trackListings: trackListings,
      pushAgent: pushAgent,
      trackAgents: trackAgents,
      pushOffice: pushOffice,
      trackOffices: trackOffices,
      showSearchHint: showSearchHint,
      hideDropdown: function () {
         var jDropdown = $("#dropdown");
         if (jDropdown.hasClass("showingSearch")) {
            jDropdown.removeClass("showingSearch");
            self.hideSearchDrop();

            if (m_strLastRequest) {
               $(".searchTextArea").text(m_strLastRequest);
            }
         }
      },
      initializeSearchHideShow: function () {
         var jDropdown = $("#dropdown"),
            jNav = $(".nav-property-search");

         $("#searchClose").click(function(e) {
            self.hideDropdown();
            e.stopPropagation();
         });
         // Summon the powers of namespaced jQuery events to ward
         // off unwanted double, triple and quadruple event triggers
         $(document).off(".search").on("click.search", function(e) {
            var target = e.target,
               bIsSearchBox = (target === jNav.get(0)),
               jClicked,
               bIsChildOfSearchBox,
               bShowFts = false;

            // Did we click in the search box?
            if (bIsSearchBox) {
               // Trigger the dropdown!
               bShowFts = true;
            } else {
               jClicked = $(target);
               bIsChildOfSearchBox = (jClicked.parents().filter(jNav).length > 0);

               // Did we click on something INSIDE the search box?
               if (bIsChildOfSearchBox) {
                  // Trigger the dropdown!
                  bShowFts = true;
               }
            }

            // Was the dropdown triggered?
            if (bShowFts) {
               // Are we using a fancy framed search?
               if (jNav.hasClass("framed-search")) {
                  // Go do that! Yeah!
                   window.location.href = "/framedsearch";
               } else {
                  // Is the dropdown already showing?
                  if (!jDropdown.hasClass("showingSearch")) {
                     // No? Show it!
                     jDropdown.addClass("showingSearch");
                     self.showSearchDrop();
                     $("#searchText").focus();
                  }
               }

               // Stop events in FTS from immediately hiding the dropdown
               // also, prevent interaction with stuff in the box if using frame search
               e.stopPropagation();
            } else {
               // Hide that dropdown!
               self.hideDropdown();
            }
         });

         $(window).on('popstate.persist pushstate.persist', function () {
            self.hideDropdown();
         });
      },
      createSearchField : function() {
         m_jBehind = $('#behindSearchText');
         m_jBox = $('#searchText');
         m_jReset = $('#searchReset');
         m_jButton = $('#searchButton');
         m_jButton.click(onSubmit);
         m_jReset.click(onReset);
         m_jBox.keydown(onKeyDown);
         m_jBox.focus(onFocus);
         m_jBox.blur(onBlur);
         m_jBox.change(onChange);
         m_jBox.bind('keydown keyup', updateBackgroundValue);
         m_strDefaultText = internationalization.getString('Enter Location') + "...";
         m_bIndexPage = (window.location.pathname === '/index.c21');
         m_jBox.attr("autocomplete", "off");

         self.initializeSearchHideShow();

         var v = $.trim(m_jBox.val());
         if ((v !== '') && (v !== m_strDefaultText)) {
            //m_strLastRequest = v;
            m_jBox.addClass('searchValue');
         } else {
            m_jBox.val(m_strDefaultText);
            m_jBox.removeClass('searchValue');
         }

         suggestPortalExtension.initPortalSearch(self);
         //$(".searchTextArea").text(m_jBox.val());
      },
      formatSearchResults : function() {
      },
      showSearchDrop : function() {
         SearchDropAnimator.showSearchDrop();
         doCollapsing();
         enlargeClickTargets();
         doHighlight();
         fixExpanding();

         require(['c21/lazy'], function (lazy) {
            lazy.load();
         });
      },
      hideSearchDrop : function() {
         SearchDropAnimator.hideSearchDrop();
      },
      handleHash : function(params) {
         if (!m_bTextDirty) {
            m_jBox.removeClass('searchValue');
            m_jBox.val(params.q);
         }

         doPortalSearch();
      },
      setText: function(str) {
         m_jBox.val(str);
         m_strLastRequest = m_jBox.val();
      },
      setBehindText: setBehindText
   };

   return self;
});
